/**
 * CLP reads the JWT from a `token` cookie on the WS upgrade (LB-3633) — a browser WebSocket cannot
 * set headers, and cookies are the one thing the browser attaches to the upgrade automatically.
 * Scoped to `/clp` so the token is not sent to every service; `secure` only for wss (a secure
 * cookie set on an insecure origin would be rejected by the browser).
 */
export const buildClpAuthCookie = (token: string, isSecure: boolean): string =>
  `token=${token}; path=/clp; samesite=strict${isSecure ? '; secure' : ''}`;

/** Expires the `token` cookie (same name+path) so the JWT does not outlive the session in the jar. */
export const clearClpAuthCookie = (): string => 'token=; path=/clp; samesite=strict; max-age=0';
